import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Box, Group, Drawer, Button, Input, TextInput, Text, useMantineTheme, ActionIcon } from '@mantine/core';
import { IconTrash, IconPlus, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_ONE, utils } from "../../utils/globalVariables";
import { removeFromArrayByIndex, changeValueOfArray, isDuplicateValueInArrayObject, isEmptyArrayObject } from "../../utils/globalFunctions";

import InputComponent from "../../components/general/InputComponent";
import ModalResponse from "../../components/general/ModalResponse";

const BarangFormCekAdd = ({
    stateShow,
    fnShow,
    fnSuccessAdd,
}) => {

    const mountedRef = React.useRef(true);
    const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmitData: 'barangFormCekAdd-1',
        successSubmitData: 'barangFormCekAdd-2',
    })

    const constBarangFormCekName = {
        id: 'addBarangFormCekName',
        label: 'Nama Form Cek',
        withAsterisk: true,
        placeholder: 'Contoh: Laptop',
        value: '',
        description: '',
        error: ''
    }

    const objectListItem = {
        value: '',
        placeholder: 'Contoh: USB Kiri'
    }

    const constBarangFormCekDetil = {
        id: 'addBarangFormCekDetil',
        label: 'List Item',
        withAsterisk: true,
        placeholder: 'List Item',
        value: [objectListItem],
        description: '',
        error: ''
    }

    const [data, setData] = React.useState({
        barangFormCekName: constBarangFormCekName,
        barangFormCekDetil: constBarangFormCekDetil,

        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const resetData = () => {
        setData(d => ({
            ...d,
            barangFormCekName: constBarangFormCekName,
            barangFormCekDetil: constBarangFormCekDetil,
        }))
    }

    const addData = () => {
        setData(d => ({
            ...d,
            barangFormCekName: { ...d.barangFormCekName, error: '' },
            barangFormCekDetil: { ...d.barangFormCekDetil, error: '' },
        }));

        if (validator.isEmpty(data.barangFormCekName.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, barangFormCekName: { ...d.barangFormCekName, error: 'Nama Form wajib diisi!', } }));
        } else if (isEmptyArrayObject(data.barangFormCekDetil.value, 'value')) {
            setData(d => ({ ...d, barangFormCekDetil: { ...d.barangFormCekDetil, error: 'Lengkapi list item terlebih dahulu atau hapus item yang kosong!' } }))
        } else if (isDuplicateValueInArrayObject(data.barangFormCekDetil.value, 'value', false)) {
            setData(d => ({ ...d, barangFormCekDetil: { ...d.barangFormCekDetil, error: 'Oppss.. Terdapat item yang sama pada list.', } }));
        } else {

            setData(d => ({ ...d, submitLoading: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('barang_form_cek_name', data.barangFormCekName.value);
            formDT.append('barang_form_cek_detil', JSON.stringify(data.barangFormCekDetil.value));

            axios({
                method: 'post',
                url: BE_API_ONE + '/add_barang_form_cek',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                if (response.data.flag_status === 'isset') {

                    resetData();
                    fnSuccessAdd();

                    notifications.show({
                        id: notificationId.current.successSubmitData,
                        title: utils.notification.success.caption,
                        message: 'Berhasil Tambah Data.',
                        color: utils.notification.success.color,
                        icon: utils.notification.success.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmitData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'duplicate-name') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: false,
                            content: `Nama barang kategori ${response.data.suspect} sudah pernah digunakan.`,
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, submitLoading: false }));

                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: false,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <Drawer
                opened={stateShow}
                onClose={fnShow}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}

                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnShow}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Text>Tambah Form Cek Barang</Text>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase'
                    }
                })}
            >
                <Box py='md'>

                    <Box mb='2rem'>
                        <InputComponent
                            stateId={data.barangFormCekName.id}
                            stateWithAsterisk={data.barangFormCekName.withAsterisk}
                            stateLabel={data.barangFormCekName.label}
                            stateDescription={data.barangFormCekName.description}
                            statePlaceHolder={data.barangFormCekName.placeholder}
                            stateValue={data.barangFormCekName.value}
                            stateError={data.barangFormCekName.error}

                            fnOnChange={(e) => setData(d => ({
                                ...d,
                                barangFormCekName: {
                                    ...d.barangFormCekName,
                                    value: e.target.value
                                }
                            }))}
                        />
                    </Box>

                    <Box mb='2rem'>
                        <Input.Wrapper
                            id={data.barangFormCekDetil.id}
                            withAsterisk={data.barangFormCekDetil.withAsterisk}
                            label={`${data.barangFormCekDetil.label} (${Array.isArray(data.barangFormCekDetil.value) ? Object.keys(data.barangFormCekDetil.value).length : 0})`}
                            description={data.barangFormCekDetil.description}
                        >
                            {Object.keys(data.barangFormCekDetil.value).map((key, index) => {
                                return (
                                    <TextInput
                                        key={key}
                                        variant='default'
                                        placeholder={data.barangFormCekDetil.value[key].placeholder}
                                        rightSection={
                                            Number(key) === 0 ?
                                                null
                                                :
                                                <IconTrash
                                                    size='1rem'
                                                    style={{ cursor: 'pointer' }}

                                                    onClick={() => setData(d => ({
                                                        ...d,
                                                        barangFormCekDetil: {
                                                            ...d.barangFormCekDetil,
                                                            value: removeFromArrayByIndex(key, data.barangFormCekDetil.value)
                                                        }
                                                    }))}
                                                />
                                        }

                                        value={data.barangFormCekDetil.value[key].value}
                                        onChange={(e) => setData(d => ({
                                            ...d,
                                            barangFormCekDetil: {
                                                ...d.barangFormCekDetil,
                                                value: changeValueOfArray(d.barangFormCekDetil.value, key, 'value', e.target.value)
                                            }
                                        }))}

                                        mb='xs'
                                    />
                                )
                            })}
                        </Input.Wrapper>

                        {data.barangFormCekDetil.error &&
                            <Text
                                c={theme.colorScheme === 'light' ? theme.colors.red[6] : theme.colors.red[8]}
                                size={theme.fontSizes.xs}
                                my='.35rem'
                            >
                                {data.barangFormCekDetil.error}
                            </Text>
                        }

                        <Group
                            spacing={5}
                            px='xs'
                            py='0.25rem'
                            position="center"

                            sx={(tema) => ({
                                borderWidth: '1px',
                                borderStyle: 'dashed',
                                borderColor: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                                borderRadius: tema.radius.sm,
                                color: tema.colorScheme === 'light' ? tema.colors.blue[6] : tema.colors.blue[6],
                                cursor: 'pointer',
                                '&:hover': {
                                    backgroundColor: tema.colorScheme === 'light' ? tema.fn.rgba(tema.colors.blue[3], 0.1) : tema.fn.rgba(tema.colors.blue[9], 0.1),
                                }
                            })}

                            onClick={() => setData(d => ({
                                ...d,
                                barangFormCekDetil: {
                                    ...d.barangFormCekDetil,
                                    value: [...d.barangFormCekDetil.value, objectListItem]
                                }
                            }))}
                        >
                            <IconPlus size='0.8rem' />
                            <Text size='sm'>Tambah Item</Text>
                        </Group>
                    </Box>

                    <Group position="apart" noWrap spacing='xs' my='xl'>
                        <Button
                            fullWidth
                            variant="default"
                            color='gray'
                            onClick={resetData}
                        >
                            Reset
                        </Button>

                        <Button
                            fullWidth
                            // variant="default"
                            // color='teal'
                            loading={data.submitLoading}
                            onClick={addData}
                        >
                            Submit
                        </Button>
                    </Group>
                </Box>
            </Drawer>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default BarangFormCekAdd;